import React from "react";
import { motion } from "framer-motion";
import { fadeUp } from "../../animations/variants";
import { useSelector } from "react-redux";
import { introText } from "../../i18n/intro";
import { useNavigate } from "react-router-dom";
import ImageSlider from "Util/ImageSlider";
import { slides } from "data/slide";

const MissionTraining = () => {
  const lang = useSelector((state) => state.language.lang);
  const t = introText[lang];
  const navigate = useNavigate();

  return (
    <section className="relative w-full overflow-hidden">
      <div className="hidden lg:block relative w-full mt-[80px] ">
        <ImageSlider slides={slides} variant="desktop" />
      </div>

      {/* ===== MOBILE GRID VERSION ===== */}
      <div className="lg:hidden flex mt-[80px] ">
        <ImageSlider slides={slides} variant="mobile" />
      </div>
    </section>
  );
};

export default MissionTraining;
